/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';

function Form({ onSubmit, children, className }) {
  return (
    <form
      className={className}
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onSubmit();
      }}
      onInvalid={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onSubmit();
      }}
      onKeyDown={({ key }) => {
        if (key === 'Enter') {
          onSubmit();
        }
      }}
    >
      {children}
    </form>
  );
}

Form.propTypes = {
  onSubmit: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Form;
